<ngx-spinner type="ball-atom"></ngx-spinner>
<div class="component-container">
  <div class="component-header">
    <h2>Stock Categories</h2>
    <div class="button-group">
      <button mat-raised-button color="primary" (click)="onStockCategoryCorrected()" *ngIf="rightItem && matchedItems && matchedItems.length > 0">
        <mat-icon>assignment_turned_in</mat-icon>
        Correct
      </button>
      <button mat-raised-button color="primary" (click)="toggleSearch()">
        <mat-icon>search</mat-icon>
        @if (isSearchVisible) { Close search } @else { Search @if (getAppliedFiltersCount() > 0) { ({{ getAppliedFiltersCount() }}) } }
      </button>
      <button mat-raised-button color="primary" (click)="onCreateStockCategory()">
        <mat-icon>add</mat-icon>
        Add Stock Category
      </button>
    </div>
  </div>
  <app-lookup-table-search-box
    [isSearchVisible]="isSearchVisible"
    (searchFilter)="onSearchFilterChange($event)">
  </app-lookup-table-search-box>
  <app-lookup-table
      [items]="stockCategories()"
      [enablePaging]="true"
      [enableMatching]="true"
      [pageSize]="25"
      [pageSizeOptions]="[5, 10, 25, 50]"
      (itemClick)="onItemSelected($event)"
      (editClick)="onEditStockCategory($event)"
      (deleteClick)="onDeleteStockCategory($event)"
      (itemSave)="onItemSave($event)"
      (itemAdd)="onItemAdd($event)"
      (readyToMatch)="onReadyToMatch($event)">
    </app-lookup-table>
</div>
